(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-grid-advanced"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const loadMoreButtons = document.querySelectorAll('[id^="LoadMore-"]');
  
  loadMoreButtons.forEach(button => {
    const sectionId = button.dataset.sectionId;
    const grid = document.getElementById('CollectionGrid-' + sectionId);
    
    if (!grid) return;
    
    const cards = grid.querySelectorAll('.collection-grid-advanced__card');
    const totalBlocks = parseInt(button.dataset.totalBlocks);
    const columnsDesktop = parseInt(button.dataset.columnsDesktop);
    const columnsTablet = parseInt(button.dataset.columnsTablet);
    const columnsMobile = parseInt(button.dataset.columnsMobile);
    const initialRows = parseInt(button.dataset.initialRows);
    
    let visibleCount = 0;
    
    function getCurrentColumns() {
      const width = window.innerWidth;
      if (width >= 992) return columnsDesktop;
      if (width >= 576) return columnsTablet;
      return columnsMobile;
    }
    
    function setupInitialState() {
      const columns = getCurrentColumns();
      const initialVisible = columns * initialRows;
      
      cards.forEach((card, index) => {
        if (index >= initialVisible) {
          card.classList.add('hidden');
        } else {
          visibleCount++;
        }
      });
      
      if (visibleCount >= totalBlocks) {
        button.classList.add('hidden');
      }
    }
    
    function loadMore() {
      if (visibleCount >= totalBlocks) return;
      
      const columns = getCurrentColumns();
      const cardsToReveal = columns;
      const endIndex = Math.min(visibleCount + cardsToReveal, totalBlocks);
      
      button.disabled = true;
      
      for (let i = visibleCount; i < endIndex; i++) {
        if (cards[i]) {
          setTimeout(() => {
            cards[i].classList.remove('hidden');
          }, (i - visibleCount) * 100);
        }
      }
      
      visibleCount = endIndex;
      
      setTimeout(() => {
        button.disabled = false;
        if (visibleCount >= totalBlocks) {
          button.classList.add('hidden');
        }
      }, (endIndex - visibleCount + cardsToReveal) * 100 + 300);
    }
    
    setupInitialState();
    
    button.addEventListener('click', loadMore);
    
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const columns = getCurrentColumns();
        const newInitialVisible = columns * initialRows;
        
        if (newInitialVisible > visibleCount) {
          const cardsToShow = Math.min(newInitialVisible, totalBlocks);
          for (let i = visibleCount; i < cardsToShow; i++) {
            if (cards[i]) {
              cards[i].classList.remove('hidden');
            }
          }
          visibleCount = cardsToShow;
        }
        
        if (visibleCount >= totalBlocks) {
          button.classList.add('hidden');
        } else {
          button.classList.remove('hidden');
        }
      }, 250);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-list-load-more"] && !Shopify.designMode) return;
  try {
    
(function() {
  function initCollectionListLoadMore() {
    const wrappers = document.querySelectorAll('.collection-list-load-more');

    wrappers.forEach(wrapper => {
      const sectionId = wrapper.dataset.sectionId;
      const desktopColumns = parseInt(wrapper.dataset.desktopColumns) || 4;
      const mobileColumns = parseInt(wrapper.dataset.mobileColumns) || 2;
      const totalItems = parseInt(wrapper.dataset.totalItems) || 0;
      const carouselOnMobile = wrapper.dataset.carouselOnMobile === 'true';

      const viewMoreBtn = document.getElementById(`ViewMoreButton-${sectionId}`);
      const closeBtn = document.getElementById(`CloseButton-${sectionId}`);
      const items = wrapper.querySelectorAll('.collection-list-load-more__item');

      let currentVisibleItems = getCurrentVisibleColumns();
      let isExpanded = false;

      // Disable load more functionality on mobile if carousel is enabled
      if (carouselOnMobile && window.innerWidth < 750) {
        if (viewMoreBtn) viewMoreBtn.classList.add('hidden');
        if (closeBtn) closeBtn.classList.add('hidden');
        return;
      }

      function getCurrentVisibleColumns() {
        return window.innerWidth < 750 ? mobileColumns : desktopColumns;
      }

      function updateVisibility() {
        const visibleCount = getCurrentVisibleColumns();

        items.forEach((item, index) => {
          const itemIndex = parseInt(item.dataset.itemIndex);
          
          if (itemIndex <= visibleCount) {
            item.classList.remove('collection-list-load-more__item--hidden');
            item.classList.remove('collection-list-load-more__item--revealing');
          } else if (itemIndex <= currentVisibleItems) {
            item.classList.remove('collection-list-load-more__item--hidden');
          } else {
            item.classList.add('collection-list-load-more__item--hidden');
          }
        });

        // Update button visibility
        if (totalItems > visibleCount) {
          if (currentVisibleItems >= totalItems) {
            if (viewMoreBtn) viewMoreBtn.classList.add('hidden');
            if (closeBtn) closeBtn.classList.remove('hidden');
            if (closeBtn) closeBtn.classList.add('visible');
          } else {
            if (viewMoreBtn) viewMoreBtn.classList.remove('hidden');
            if (closeBtn) closeBtn.classList.add('hidden');
            if (closeBtn) closeBtn.classList.remove('visible');
          }
        } else {
          if (viewMoreBtn) viewMoreBtn.classList.add('hidden');
          if (closeBtn) closeBtn.classList.add('hidden');
        }
      }

    function revealNextRow() {
  const visibleCount = getCurrentVisibleColumns();

  const rowsToReveal = window.innerWidth < 750 ? 3 : 1;

  const nextVisibleItems =
    currentVisibleItems + (visibleCount * rowsToReveal);

  if (nextVisibleItems > totalItems) {
    currentVisibleItems = totalItems;
  } else {
    currentVisibleItems = nextVisibleItems;
  }

  items.forEach((item) => {
    const itemIndex = parseInt(item.dataset.itemIndex);

    if (
      itemIndex > currentVisibleItems - (visibleCount * rowsToReveal) &&
      itemIndex <= currentVisibleItems
    ) {
      item.classList.remove('collection-list-load-more__item--hidden');
      item.classList.add('collection-list-load-more__item--revealing');
    }
  });

  isExpanded = true;
  updateVisibility();
  updateAriaStates();
}

      function collapseToFirstRow() {
        const visibleCount = getCurrentVisibleColumns();
        currentVisibleItems = visibleCount;

        items.forEach((item, index) => {
          const itemIndex = parseInt(item.dataset.itemIndex);
          if (itemIndex > visibleCount) {
            item.classList.add('collection-list-load-more__item--hidden');
            item.classList.remove('collection-list-load-more__item--revealing');
          }
        });

        isExpanded = false;
        updateVisibility();
        updateAriaStates();

        // Smooth scroll back to section
        wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      function updateAriaStates() {
        if (viewMoreBtn) {
          viewMoreBtn.setAttribute('aria-expanded', isExpanded.toString());
        }
        if (closeBtn) {
          closeBtn.setAttribute('aria-expanded', isExpanded.toString());
        }
      }

      function handleResize() {
        const newVisibleColumns = getCurrentVisibleColumns();
        
        // Only reset if not expanded and column count changed
        if (!isExpanded && currentVisibleItems !== newVisibleColumns) {
          currentVisibleItems = newVisibleColumns;
          updateVisibility();
          updateAriaStates();
        }
      }

      // Event listeners
      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('click', revealNextRow);
      }

      if (closeBtn) {
        closeBtn.addEventListener('click', collapseToFirstRow);
      }

      // Keyboard accessibility
      if (viewMoreBtn) {
        viewMoreBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            revealNextRow();
          }
        });
      }

      if (closeBtn) {
        closeBtn.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            collapseToFirstRow();
          }
        });
      }

      // Handle window resize with debounce
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
      });

      // Initialize visibility
      updateVisibility();
      updateAriaStates();
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionListLoadMore);
  } else {
    initCollectionListLoadMore();
  }

  // Re-initialize on section load (for theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.collection-list-load-more')) {
      initCollectionListLoadMore();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
